import React from 'react';

const EditIcon = props => {
    return (
        <svg width='1.75rem' height='1.75rem' viewBox='0 0 28 28' {...props}>
            <path d='M7.857 22.197c-1.225.258-2.31-.828-2.054-2.053l.634-3.028L17.28 6.273c.677-.678 1.775-.678 2.452 0l1.995 1.995c.678.677.678 1.774 0 2.453l-10.9 10.9h-.23l-2.74.576zm12.87-12.476c.125-.126.125-.328 0-.453l-1.995-1.995c-.125-.125-.327-.125-.451 0L7.736 17.818l-.549 2.616c-.047.226.153.426.378.379l2.62-.55L20.725 9.72z' />
        </svg>
    );
};

export default EditIcon;
